import { useState } from "react";
import ReactDOM from "react-dom";
import PopupCard from "./popupcard";
import MessengerChat from "./messenger";
import OfferButton from "./offerbutton";
import {
  Box,
  SpeedDial,
  SpeedDialAction,
  SpeedDialIcon,
  useMediaQuery,
} from "@mui/material";
import { FaFacebookMessenger, FaGift } from "react-icons/fa";
import { useLocation } from "react-router";
import { fabMarginByScreen } from "../../lib/consts";

const FabSection = () => {
  const [open, setOpen] = useState(false);
  const [dialOpen, setDialOpen] = useState(true);
  const isMobile = useMediaQuery("(max-width:768px)");
  const location = useLocation();

  const handleOffersClick = () => {
    setOpen(true);
    setDialOpen(false);
  };
  const handleMessengerClick = () => {
    window.open("https://m.me/105369105154018", "_blank");
    setDialOpen(false);
  };

  if (isMobile) {
    return ReactDOM.createPortal(
      [
        open && (
          <div className="fixed inset-0 bg-black/60 z-50">
            <PopupCard onClose={() => setOpen(false)} />
          </div>
        ),
        <SpeedDial
          ariaLabel="Quick actions"
          sx={{
            position: "fixed",
            bottom:
              fabMarginByScreen[location.pathname.replaceAll("/", "")] || 16,
            right: 16,
          }}
          icon={<SpeedDialIcon />}
          open={dialOpen}
          onClose={() => setDialOpen(false)}
          onOpen={() => setDialOpen(true)}
        >
          <SpeedDialAction
            icon={
              <Bubble
                title="Quick Chat"
                icon={<FaFacebookMessenger size={25} />}
              />
            }
            onClick={handleMessengerClick}
          />

          <SpeedDialAction
            icon={<Bubble title="Offers" icon={<FaGift size={25} />} />}
            onClick={handleOffersClick}
          />
        </SpeedDial>,
      ],
      document.getElementById("fab-root")
    );
  }
  return ReactDOM.createPortal(
    <div className="fixed bottom-24 right-6 md:right-14 md:bottom-16 z-50 flex flex-col items-end gap-4">
      {/* POPUP CARD */}
      {open && <PopupCard onClose={() => setOpen(false)} />}

      {/* OFFER BUTTON WITH IMAGE */}
      <OfferButton onClick={() => setOpen(!open)} />

      {/* MESSENGER BUTTON */}
      <MessengerChat />
    </div>,
    document.getElementById("fab-root")
  );
};

function Bubble({ title, icon }) {
  return (
    <Box className="relative flex items-center">
      {/* LEFT LABEL */}
      <span
        className="
          absolute right-full mr-3
          bg-white/80 text-black text-xs
          p-2 rounded
          whitespace-nowrap
          shadow-lg
        "
      >
        {title}
      </span>

      {/* ICON */}
      {icon}
    </Box>
  );
}

export default FabSection;
